import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import Loading from './components/Loading';
import Router from './router';
import { useLoadingStore } from './store/useLoadingStore.ts';

import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const { hideLoading, showLoading } = useLoadingStore();

  useEffect(() => {
    showLoading('Iniciando');

    setTimeout(() => {
      hideLoading();
    }, 4000);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router />
      <Loading />
    </QueryClientProvider>
  );
};

export default App;
